import Cookies from 'js-cookie'

const COOKIE_STORAGE_KEY = 'cookies_preferences'

export const getCookiePreferences = () => {
  const stored = Cookies.get(COOKIE_STORAGE_KEY)

  // Logica per gestire i valori di default se il cookie è assente
  if (stored) {
    try {
      return JSON.parse(stored)
    } catch (e) { /* fallthrough to default */ }
  }

  // Ritorna lo stato di default: tutto bloccato tranne i tecnici
  return {
    technical: true,
    analytics: false,
    marketing: false
  }
}

/**
 * Controlla se l'utente ha dato il consenso per i cookie analitici (es. GA).
 */
export const canLoadAnalytics = () => {
  return getCookiePreferences().analytics === true
}

/**
 * Controlla se l'utente ha dato il consenso per i cookie di marketing.
 */
export const canLoadMarketing = () => {
  return getCookiePreferences().marketing === true
}
